<template>
    <div class="menu-wrapper">
        <div class="menu">
            <button class="menu-btn" @click="choosedRobot('pexercises')"
                :class="robotId === 'pexercises' ? 'selected' : ''">🌱小学智能体</button>
            <button class="menu-btn" @click="choosedRobot('mexercises')"
                :class="robotId === 'mexercises' ? 'selected' : ''">🌿初中智能体</button>
            <button class="menu-btn" @click="choosedRobot('exercises')"
                :class="robotId === 'exercises' ? 'selected' : ''">🌳高中智能体</button>
            <button class="menu-btn" @click="choosedRobot('composition')"
                :class="robotId === 'composition' ? 'selected' : ''">📝组卷智能体</button>
            <button class="menu-btn" @click="openAdvanced">
                🧭带着地图学习
                <span class="kg-unread-dot" v-if="kgUnread"></span>
            </button>
            <button class="menu-btn" @click="openLevel">📈 我的数学水平</button>
            <button class="menu-btn" @click="choosedRobot('wrong')">❌我的错题本</button>
            <button class="menu-btn" @click="choosedRobot('wall')">🧱我的知识墙</button>
            <button class="menu-btn" @click="toCollect('collect')">📁我的收藏本</button>
            <button class="menu-btn" @click="openHistoryPanel">🕒聊天记录</button>
            <collect class="collect-panel" v-show="showCollect" :showCollect="showCollect" :full="true" :isMobile="true"
                @hideCollect="hideCollect">
            </collect>
            <my-level class="level-panel" v-show="showLevel" :showLevel="showLevel" :score="score" :full="true"
                @hideLevel="hideLevel"></my-level>
            <!-- 新增：带着地图学习弹窗 -->
            <AdvancedLearning
                v-if="showAdvanced"
                :kg-id="advancedKgId"
                :paint-data="advancedPaintData"
                :level="currentLevel"
                @close="onAdvancedClose"
            />
        </div>
    </div>
</template>

<script>
import store from "@/store/index";
import robotMixin from "@/mixin/robot.js";
import collect from "@/components/mobile/collect"
import myLevel from "@/components/mobile/level"
import AdvancedLearning from "@/components/AdvancedLearning.vue";
// ★ 新增：后台流订阅 + 未读状态（与桌面端 chatRobot 同源）
import { subscribe, hasUnseenFlows } from "@/utils/learning/backgroundFlow";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
    name: 'toolbar',
    data() {
        return {
            selected: "exercises",
            showCollect: false,
            showLevel: false,
            ele: {},
            // 图谱弹窗相关
            showAdvanced: false,
            advancedKgId: "",
            advancedPaintData: null,
            currentLevel: "",
            kgUnread: false, // ★ 图谱学习入口红点
        }
    },
    components: {
        collect,
        myLevel,
        AdvancedLearning,
    },
    mixins: [robotMixin],
    computed: {
        ...mapState(['foldRobot', 'foldHistory', "robotId",
            "robots",
            "messageStorage",
            "user",
            "sessionId",
            "robotSessionMap",
            "papers",
            "isMobile"])
    },
    mounted() {
        this.ele = document.querySelector(".user-avatar");
        // ★ 订阅后台流状态：任何流开始/完成 → 刷新红点
        this._unsubKgFlow = subscribe(() => {
            this.kgUnread = hasUnseenFlows();
        });
        // 页面刷新后从快照恢复
        this.kgUnread = hasUnseenFlows();
    },
    beforeDestroy() {
        // ★ 取消订阅，防内存泄漏
        this._unsubKgFlow && this._unsubKgFlow();
    },
    methods: {
        openRobotPanel() {
            store.commit("SET_FOLDROBOT", false);
        },

        openHistoryPanel() {
            store.commit("SET_FOLDHISTORY", false);
        },
        toCollect() {
            this.$router.push('/collect')
        },
        hideCollect() {
            this.$router.go(-1)
        },
        openLevel() {
            this.$router.push('/level')
            this.choosedRobot('mathLevel')
        },
        hideLevel() {
            this.$router.go(-1)
        },
        // ★ 打开图谱学习弹窗（空参打开，由弹窗自行恢复最新现场）
        async openAdvanced() {
            this.kgUnread = false; // 主动进入 → 红点立即熄灭
            const ROBOT_LEVEL = { exercises: "h", mexercises: "m", pexercises: "p" };
            this.currentLevel = ROBOT_LEVEL[this.robotId] || "";
            // ★ 不再预加载 showGraphNames/showGraph 传参，
            // 弹窗 mounted 自动加载"有流/有快照/有未读"的最新图谱
            this.showAdvanced = true;
            if (this.isMobile) {
                store.commit("SET_FOLDROBOT", true);
            }
        },
        onAdvancedClose() {
            this.showAdvanced = false;
            this.advancedPaintData = null;
            this.advancedKgId = "";
            // ★ 关闭后同步一次红点状态
            this.kgUnread = hasUnseenFlows();
        },
    },
    watch: {
        showLevel(newVal, oldVal) {
            if (newVal) {
                this.ele.style.zIndex = 0
            } else {
                this.ele.style.zIndex = 1
            }
        }
    }
}
</script>


<style lang="scss">
.menu-wrapper {
width: 100%;
overflow-x: auto;            // 保留滚动能力
scrollbar-width: thin;       // Firefox 细条
&::-webkit-scrollbar {
    height: 2px;               // 细滚动条
}
&::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 1px;
}
&::-webkit-scrollbar-track {
    background: transparent;
}
}

.menu {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    padding-bottom: 4px;
    padding-top: 1px;
    background-color: var(--rightbox-bg-color);
    .menu-btn {
        margin-right: 10px;
        padding: 5px 8px;
        min-width: fit-content;
        display: flex;
        align-items: center;
        border: 1px solid var(--border-exercise);
        border-radius: 10px;
        color: #000;
        font-size: clamp(12px, 0.14rem, 16px);
        font-weight: 500;
        background-color: #fff;
        cursor: pointer;

        &.selected {
            border: 1px solid var(--txt-color-blue);
            color: var(--txt-color-blue);
        }
    }
}

.collect-panel,
.level-panel {
    position: absolute;
    width: 100vw !important;
    height: 100vh !important;
    left: 0 !important;
    right: 0 !important;
    top: 0;
    background-color: #fff;
    z-index: 100000;

    ::v-deep ul {
        margin-left: 0;
    }

}
.menu-btn {
    position: relative;
}
.kg-unread-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    margin-left: 4px;
    border-radius: 50%;
    background: #f56c6c;
    vertical-align: middle;
    animation: kg-dot-blink 1.2s ease-in-out infinite;
}
@keyframes kg-dot-blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
}
</style>